'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { Suspense } from 'react';
import { AppHeader } from '@/components/layout/app-header';
import { DeferredLandingStyles } from '@/components/layout/deferred-landing-styles';
import { LandingMobileCta } from '@/components/support-mainnet/landing-mobile-cta';
import { CONTENT_MIN_H_CLASS, GUTTER_CLASS, LANDING_CONTENT_VERTICAL_CLASS } from '@/lib/ui/layout';
import { cn } from '@/lib/ui/utils';
const LANDING_CHROME_HEIGHT_STYLE = {
  '--app-header-chrome-height': '5rem'
} as React.CSSProperties;
export function LandingAppShell(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DeferredLandingStyles />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Suspense fallback={null}><AppHeader /></Suspense>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn(GUTTER_CLASS, LANDING_CONTENT_VERTICAL_CLASS, CONTENT_MIN_H_CLASS, "flex flex-1 flex-col");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <main className="flex min-h-0 min-w-0 w-full flex-1 flex-col bg-background-secondary"><div className={t3}>{children}</div></main>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LandingMobileCta />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <div className="flex min-h-dvh flex-col" style={LANDING_CHROME_HEIGHT_STYLE}>{t1}{t2}{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}